import { startTransition } from 'react';
import { Container } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as SAL1Logo } from 'src/images/svgs/certifications/sal1-badge-pattern.svg';
import { ReactComponent as PT1Logo } from 'src/images/svgs/certifications/pt1_top_banner.svg';
import { useSegmentTracking } from 'src/common/hooks/use-segment-tracking';
import { StyledCertificationLogo, StyledH2CertificationBannerTitle, StyledPCertificationBannerDescription, StyledCertificationBanner, StyledCertificationBannerContentWrapper, StyledCertificationBannerTextWrapper, StyledCertificationButton, StyledH2CertificationBannerTitleSpan, StyledCloseButton } from './certification-banner.styles';
import { CertificationBannerProps } from './certification-banner.types';
import { certificationBannerContent } from './certification-banner-content';
export const CertificationBanner = ({
  dismiss,
  isTopBanner,
  type
}: CertificationBannerProps) => {
  const navigate = useNavigate();
  const {
    triggerButtonClickEvent
  } = useSegmentTracking();
  const content = certificationBannerContent[type];
  const handleLearnMore = () => {
    triggerButtonClickEvent(content.segmentEventName, content.segmentEventCategory, content.segmentEventAction);
    startTransition(() => navigate(content.learnMorePath));
  };
  return <StyledCertificationBanner data-testid="certification-banner" $isTopBanner={isTopBanner} data-sentry-element="StyledCertificationBanner" data-sentry-component="CertificationBanner" data-sentry-source-file="certification-banner.tsx">
      {isTopBanner && <StyledCloseButton onClick={dismiss} data-testid="certification-banner-close">
          <FontAwesomeIcon icon={faXmark} />
        </StyledCloseButton>}
      <Container data-sentry-element="Container" data-sentry-source-file="certification-banner.tsx">
        <StyledCertificationBannerContentWrapper data-sentry-element="StyledCertificationBannerContentWrapper" data-sentry-source-file="certification-banner.tsx">
          <StyledCertificationBannerTextWrapper $isTopBanner={isTopBanner} data-sentry-element="StyledCertificationBannerTextWrapper" data-sentry-source-file="certification-banner.tsx">
            {isTopBanner && <StyledH2CertificationBannerTitle>
                <StyledH2CertificationBannerTitleSpan $isTopBanner={isTopBanner}>
                  NEW
                </StyledH2CertificationBannerTitleSpan>
              </StyledH2CertificationBannerTitle>}
            <StyledH2CertificationBannerTitle data-sentry-element="StyledH2CertificationBannerTitle" data-sentry-source-file="certification-banner.tsx">
              {content.titleSpan ? content.title.split(content.titleSpan)[0] : content.title}
              {content.titleSpan && <StyledH2CertificationBannerTitleSpan>{content.titleSpan}</StyledH2CertificationBannerTitleSpan>}
              {content.titleSpan && content.title.split(content.titleSpan)[1]}
            </StyledH2CertificationBannerTitle>
            <StyledPCertificationBannerDescription data-sentry-element="StyledPCertificationBannerDescription" data-sentry-source-file="certification-banner.tsx">{content.description}</StyledPCertificationBannerDescription>
            <StyledCertificationButton onClick={handleLearnMore} data-sentry-element="StyledCertificationButton" data-sentry-source-file="certification-banner.tsx">Learn more</StyledCertificationButton>
          </StyledCertificationBannerTextWrapper>
          <StyledCertificationLogo $type={type} data-sentry-element="StyledCertificationLogo" data-sentry-source-file="certification-banner.tsx">{type === 'SAL1' ? <SAL1Logo /> : <PT1Logo />}</StyledCertificationLogo>
        </StyledCertificationBannerContentWrapper>
      </Container>
    </StyledCertificationBanner>;
};